import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './Auth.css';

const API_URL = process.env.REACT_APP_API_URL;

function VerifyEmail() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  // StrictMode geliştirme modunda effect iki kez çalışır; token tek kullanımlık olduğu için tek istek atılır
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/users/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json();
        setStatus(res.ok ? 'success' : 'error');
        setMessage(data.message || data.error || '');
      } catch (err) {
        console.error('Doğrulama hatası:', err);
        setStatus('error');
        setMessage('Sunucuya bağlanılamadı.');
      }
    })();
  }, [token]);

  return (
    <div className="auth-page">
      <main className="auth-main">
        <div className="auth">
          <span className="auth-kicker">E-posta doğrulama</span>
          <h1>
            {status === 'loading' && 'Doğrulanıyor...'}
            {status === 'success' && 'Hesabınız etkinleştirildi'}
            {status === 'error' && 'Doğrulama başarısız'}
          </h1>
          {message && <p className="auth-sub">{message}</p>}
          {status !== 'loading' && (
            <p className="auth-footer">
              <Link to="/login">Giriş sayfasına git</Link>
            </p>
          )}
        </div>
      </main>
    </div>
  );
}

export default VerifyEmail;